export default function last(fn) {
  var lastToken = { cancel: function () {} }; // start with no op
  return function () {
    lastToken.cancel();
    var args = Array.prototype.slice.call(arguments);
    args.push(lastToken);
    return fn.apply(this, args);
  };
}
